<div class="gb_pre_head">
  <div class="container">
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-end">
        <!-- [x]: F24 - Communications - Se ci sono nuove, ci deve essere il n° e il pallino rosso (class="gb-new-notMes") e deve aprirsi il popup altrimenti deve andare alla pagina dedicata -->
        <a class="gb-new-notMes" href="javascript:void(0)" (click)="openPreHeadModal('communications', messageService.numOfCommunications)" tabindex="0">
          <em [ngClass]="{ 'notifications-active' : messageService.numOfCommunications > 0 }" class="gb-speak-none" aria-hidden="true">
            <svg viewBox="0 0 101 101">
              <path class="st0" d="M50.5,0C22.6,0,0,22.6,0,50.5C0,78.4,22.6,101,50.5,101c27.9,0,50.5-22.6,50.5-50.5C101,22.6,78.4,0,50.5,0z
 M77.6,74.9c0,0.9-0.8,1.7-1.7,1.7c-0.5,0-0.9-0.2-1.2-0.5l-9.8-9.8c-0.6-0.6-1.5-1-2.4-1H29.7c-3.8,0-6.8-3.1-6.8-6.8V31.2
c0-3.8,3.1-6.8,6.8-6.8h41.1c3.8,0,6.8,3.1,6.8,6.8V74.9z" />
            </svg>
          </em>
          <span *ngIf="messageService.numOfCommunications > 0">{{ 'communications'|translate:{numOfCommunications: messageService.numOfCommunications} }}</span>
          <span *ngIf="messageService.numOfCommunications == 0">{{ 'empty_communications'|translate }}</span>
        </a>

        <!-- [x]: F24 - Notifications - Se ci sono nuove, ci deve essere il n° e il pallino rosso (class="gb-new-notMes") e deve aprirsi il popup altrimenti deve andare alla pagina dedicata -->
        <a class="gb-new-notMes" href="javascript:void(0)" (click)="openPreHeadModal('notifications', messageService.numOfNotifications)" tabindex="0">
          <em [ngClass]="{ 'notifications-active' : messageService.numOfNotifications > 0 }" class="gb-speak-none" aria-hidden="true">
            <svg viewBox="0 0 40 40">
              <path d="M20,33.2c0.8,0,1.4-0.3,2-0.8c0.6-0.6,0.8-1.2,0.8-2h-5.6c0,0.8,0.3,1.4,0.9,2C18.6,32.9,19.2,33.2,20,33.2z M10.3,27.4
h19.4v-3h-2v-5.8c0-2-0.5-3.8-1.6-5.5c-1.1-1.7-2.5-2.7-4.4-3.1V8.5c0-0.5-0.2-0.9-0.5-1.2C20.9,7,20.5,6.9,20,6.9
c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.3-0.5,0.7-0.5,1.2V10c-1.9,0.4-3.4,1.4-4.4,3c-1.1,1.6-1.6,3.4-1.6,5.4v6.1h-2L10.3,27.4z M20,40
c-2.7,0-5.3-0.5-7.8-1.6c-2.4-1-4.6-2.5-6.4-4.3s-3.2-3.9-4.3-6.4S0,22.7,0,20c0-2.8,0.5-5.4,1.6-7.8s2.5-4.5,4.3-6.4
s3.9-3.2,6.4-4.3S17.3,0,20,0c2.8,0,5.4,0.5,7.8,1.6s4.6,2.5,6.3,4.3c1.8,1.8,3.2,3.9,4.3,6.4c1.1,2.4,1.6,5,1.6,7.8
c0,2.7-0.5,5.3-1.6,7.8c-1,2.4-2.5,4.6-4.3,6.4c-1.8,1.8-3.9,3.2-6.4,4.3C25.4,39.5,22.8,40,20,40z" />
            </svg>
          </em>
          <span *ngIf="messageService.numOfNotifications > 0">{{ 'notifications'|translate:{numOfNotifications: messageService.numOfNotifications} }}</span>
          <span *ngIf="messageService.numOfNotifications == 0">{{ 'empty_notifications'|translate }}</span>
        </a>

        <!-- Support -->
        <ng-container *ngIf="storeService.codIpa != null && storeService.codIpa != ''">
          <a [routerLink]="['/'+ storeService.codIpa +'/support']" title="{{ 'support' | translate }}" attr.aria-label="{{ 'support' | translate }}" tabindex="0">
            <em class="gb-speak-none" aria-hidden="true">
              <svg viewBox="0 0 101 101">
                <path class="st0" d="M50.5,0C22.6,0,0,22.6,0,50.5C0,78.4,22.6,101,50.5,101c27.9,0,50.5-22.6,50.5-50.5C101,22.6,78.4,0,50.5,0z
   M77.6,74.9c0,0.9-0.8,1.7-1.7,1.7c-0.5,0-0.9-0.2-1.2-0.5l-9.8-9.8c-0.6-0.6-1.5-1-2.4-1H29.7c-3.8,0-6.8-3.1-6.8-6.8V31.2
  c0-3.8,3.1-6.8,6.8-6.8h41.1c3.8,0,6.8,3.1,6.8,6.8V74.9z" />
              </svg>
            </em>
            <span>{{ 'support' | translate }}</span>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- [x]: F24 - Communications -->
<div id="popup-communications" class="gb-popup pp-notifiche d-none" data-tipo="custompopup-communications" aria-labelledby="alert-custompopup-communications" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h2_pp">{{ 'messages-communications-title' | translate }}</span>
      <button type="button" title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset" tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <hr />
      <ng-container *ngFor="let item of messageService.communicationsNotReadCollection">
        <ng-container *ngIf="!item.letta">
          <div class="d-flex justify-content-between">
            <div>
              <small class="fs-6">{{item.dataComunicazione | date:'dd/MM/yyyy HH:mm'}}</small>
              <h6><b>{{item.titolo}}</b></h6>
            </div>
            <i *ngIf="!messageService.loadingOperation" class="bi-check-all checkAsReadButton" (click)="checkCommunicationAsRead(item, 'communications')"
              [matTooltip]="'messages-mark-as-read' | translate"
              [matTooltipPosition]="'after'"></i>
            <div *ngIf="messageService.loadingOperation" class="spinner-border spinner-border-sm mt-3 me-1" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div>{{item.descrizione}}</div>
          <hr />
        </ng-container>
      </ng-container>
    </div>
    <div class="gb-popup-foot d-flex justify-content-center">
      <a href="javascript:void(0)" (click)="closeModalAndGoToLink('communications', '/communications/info')">
        <i class="bi bi-box-arrow-up-right popupLinkButton"></i>
        {{ 'messages-communications-go-to-page' | translate }}
      </a>
    </div>
  </div>
</div>
<!-- [x]: F24 - Notifications -->
<div id="popup-notifications" class="gb-popup pp-notifiche d-none" data-tipo="custompopup-notifications" aria-labelledby="alert-custompopup-notifications" aria-hidden="true">
  <div class="gb-popup-inner">
    <div class="gb-popup-header">
      <span class="gb_h2_pp">{{ 'messages-notifications-title' | translate }}</span>
      <button type="button" title="{{ 'footer-modale-chiudi' | translate }}"
        attr.aria-label="{{ 'footer-modale-chiudi' | translate }}" tabindex="0" class="gb-close-pp gb-button-reset" tabindex="0">
        <span>
          <em></em>
          <em></em>
          <em></em>
        </span>
        <em class="gb-hidden-visually gb-speak">{{ 'footer-modale-chiudi' | translate }}</em>
      </button>
    </div>
    <div class="gb-popup-main">
      <hr />
      <ng-container *ngFor="let item of messageService.notificationsNotReadCollection">
        <ng-container *ngIf="!item.letta">
          <div class="d-flex justify-content-between">
            <div>
              <small class="fs-6">{{item.dataNotifica | date:'dd/MM/yyyy HH:mm'}}</small>
              <h6><b>{{item.titolo}}</b></h6>
            </div>
            <i *ngIf="!messageService.loadingOperation" class="bi-check-all checkAsReadButton" (click)="checkNotificationAsRead(item, 'notifications')"
              [matTooltip]="'messages-mark-as-read' | translate"
              [matTooltipPosition]="'after'"></i>
            <div *ngIf="messageService.loadingOperation" class="spinner-border spinner-border-sm mt-3 me-1" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
          <div>{{item.descrizione}}</div>
          <hr />
        </ng-container>
      </ng-container>
    </div>
    <div class="gb-popup-foot d-flex justify-content-center">
      <a href="javascript:void(0)" (click)="closeModalAndGoToLink('notifications', '/notifications/info')">
        <i class="bi bi-box-arrow-up-right popupLinkButton"></i>
        {{ 'messages-notifications-go-to-page' | translate }}
      </a>
    </div>
  </div>
</div>
